import {
    MS_YEAR,
    WORK_DAYS_MONTH,
    WORK_DAYS_YEAR,
    TREE_ABSORPTION_YEAR,

    FUELS,
    NOX_NO2,
    TRANSIT_EMISSIONS,
    WALKING_EMISSIONS,
    BICYCLING_EMISSIONS,
    CONSUMPTION_AMOUNT
} from '@/const';

function getConsumption (data) {
    var fuel = FUELS[data.fuel],
        consumptionCategory = CONSUMPTION_AMOUNT[data.fuel] || CONSUMPTION_AMOUNT.default,
        consumption = consumptionCategory[data.vehicle] || 0;

    if (fuel && fuel.consumptionCoef) {
        consumption *= fuel.consumptionCoef;
    }

    return consumption;
}

function vehicleCO2 (journey) {
    var fuel = FUELS[journey.fuel],
        consumptionPerKm = 0,
        emissions = 0;

    if (fuel.emissionsLitre) {
        consumptionPerKm = journey.consumption / 100; // l/100km to l/km
        emissions += fuel.emissionsLitre * consumptionPerKm;
    }

    if (fuel.emissionsKwh) {
        consumptionPerKm = journey.consumption / 100; // kWh/100km to kWh/km
        emissions += fuel.emissionsKwh * consumptionPerKm;
    }

    if (fuel.emissionsKm) {
        emissions += fuel.emissionsKm;
    }

    return emissions;
}

function vehicleNOX (journey) {
    var fuel = FUELS[journey.fuel],
        emissions = 0;

    if (fuel.noxLitre) {
        var consumptionPerKm = journey.consumption / 100; // consumption is in l/100km
        emissions += fuel.noxLitre * consumptionPerKm;
    }

    return emissions;
}

function transportCO2 (transportName, transportData, journey) {
    if (transportData.isTransit) {
        var transitEmissions = TRANSIT_EMISSIONS[transportName];

        if (transitEmissions && typeof transitEmissions.passenger === 'number') {
            return transitEmissions.passenger;
        } else {
            console.warn('No emissions data for:', transportName);
            return 0;
        }
    } else {
        switch (transportName) {
        case 'DRIVING': return vehicleCO2(journey);
        case 'WALKING': return WALKING_EMISSIONS;
        case 'BICYCLING': return BICYCLING_EMISSIONS;
        default: return 0;
        }
    }
}

function calculate (travelMode, journey) {
    var totalCO2 = 0,
        totalNOX = 0,
        distance = 0;

    for (var k in travelMode.transports) {
        var transport = travelMode.transports[k];
        var transportDistance = (transport.distance / 1000);

        var currentEmissions = transportCO2(k, transport, journey);
        var currentTotalEmissions = currentEmissions * transportDistance;

        totalCO2 += currentTotalEmissions;
        distance += transportDistance;

        if (k === 'DRIVING') {
            totalNOX += vehicleNOX(journey) * transportDistance;
        }
    }

    return {
        total: totalCO2,
        kilometer: totalCO2 / distance,
        nox: totalNOX,
        no2: totalNOX * NOX_NO2
    };
}

export default {
    calculate,
    getConsumption,
    dailyRouteEmissions (emissions) {
        return {
            monthly: emissions * WORK_DAYS_MONTH,
            yearly: emissions * WORK_DAYS_YEAR
        };
    },
    timeToAbsorb (emissions) {
        var yearsToAbsorb = (emissions / TREE_ABSORPTION_YEAR);
        return yearsToAbsorb * MS_YEAR;
    }
};
